'use strict';

( function ( $ ) {
	$( document ).on( 'click', '.site-header__search', function () {
		$( '.search-modal' ).addClass( 'show' );
	} );

	$( document ).on( 'click', '.search-modal__close', function () {
		$( '.search-modal' ).removeClass( 'show' );
	} );

	// $( document ).on( 'click', '.privacy-modal__close', function () {
	// 	$( '.privacy-modal' ).hide();
	// } );

	// $( document ).on( 'click', '.form-modal__privacy-open', function () {
	// 	$( '.privacy-modal' ).show();
	// } );

	// $( document ).ready( function () {
	// 	$( '.privacy-modal__content' ).scroll( function () {
	// 		$( this ).addClass( 'no-gradient' );
	// 	} );
	// } );
} )( jQuery );
